<template>
  <div class="page-upgrade">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2">Upgrade My Listing</h1>
  </div>
</template>

<script>
export default {
  name: 'Upgrade',
};
</script>
